"use client";

import { ResponsiveLayout } from "@/components/common/ResponsiveLayout";
import { SimpleCrystalSelector } from "@/components/product/CrystalSelector";
import { FontSelector } from "@/components/product/FontSelector";
import { TextInput } from "@/components/product/TextInput";
import { TextPreview } from "@/components/product/TextPreview";
import { SectionTitle } from "@/components/sticker/StickerCustomizer/SectionTitle";
import { Separator } from "@/components/ui/separator";
import { useCrystalCustomizer } from "@/contexts/CrystalCustomizerContext";

/**
 * 水晶定制组件 - 专注UI组件编排
 * 使用ResponsiveLayout实现响应式section布局
 */
export function CrystalCustomizer() {
  // 从Context获取核心共享状态
  const { config, setText, setSelectedFont, setCrystalType } =
    useCrystalCustomizer();

  return (
    <ResponsiveLayout>
      {/* Section 1: Crystal Model 选择 */}
      <div className="h-full overflow-y-auto">
        <div className="p-4">
          <SectionTitle title="Crystal Model" />
          <div className="space-y-3">
            <SimpleCrystalSelector
              selectedCrystal={config.crystalType}
              onCrystalSelect={setCrystalType}
            />
          </div>
        </div>
        <div className="hidden md:block">
          <Separator />
        </div>
      </div>

      {/* Section 2: Text Settings & Preview (文本编辑与预览) */}
      <div className="h-full overflow-y-auto">
        <div className="p-4">
          <SectionTitle title="Text Settings" />
          <div className="space-y-3">
            <TextPreview
              text={config.text}
              selectedFont={config.selectedFont}
            />
            <FontSelector
              value={config.selectedFont}
              onChange={setSelectedFont}
            />
            <TextInput
              value={config.text}
              onChange={setText}
              placeholder="Enter text to engrave..."
              maxLength={50}
            />
          </div>
        </div>
      </div>
    </ResponsiveLayout>
  );
}
